import React from 'react'
import { styled } from '@material-ui/core'
import type { ItemTableCellProps } from '../../../ItemTable/ItemTableCell'
import ItemTableCell from '../../../ItemTable/ItemTableCell'

const AreaSubstrateHeaderCell = styled((props: ItemTableCellProps) => <ItemTableCell {...props} />)(
  {
    fontSize: '13px',
    fontWeight: 500,
    padding: '0.5em 1em',
    whiteSpace: 'nowrap'
  },
  {
    name: 'AreaSubstrateHeaderCell'
  }
)

export default AreaSubstrateHeaderCell
